import { Link } from 'react-router-dom';
import SEO from '../components/SEO';
export default function NotFound() {
  return (
    <>
      <SEO title="404 — Page Not Found" description="This page does not exist." noIndex />
      <section className="min-h-screen flex items-center justify-center bg-grid-black py-20">
        <div className="text-center max-w-md mx-auto px-5">
          <p className="text-9xl text-white/5 leading-none" style={{fontFamily:'Anton,sans-serif',fontWeight:500}} aria-hidden="true">404</p>
          <h1 className="text-4xl text-white -mt-4 mb-3" style={{fontFamily:'Anton,sans-serif',fontWeight:500}}>PAGE NOT FOUND.</h1>
          <p className="text-white/40 text-sm mb-8">This page doesn't exist or has been moved. Let's get you back on track.</p>
          <div className="flex flex-wrap items-center justify-center gap-3">
            <Link to="/" className="btn-primary-inv">Go Home</Link>
            <Link to="/contact" className="btn-outline-inv">Contact Us</Link>
          </div>
        </div>
      </section>
    </>
  );
}
